import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import { getCourseList, getExam, getExamByPost } from "../../api/service.js"
import { getCourseListByPost } from "../../api/service";

let that;
let int;
Date.prototype.Format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;

};
export default {
  components: {
    HeadCom,
    FooterCom,
  },
  data() {
    return {
      contentHeight: { 'max-height': window.innerHeight -305 + 'px' },
      radio: [],
      examObj: {},
      oldExamObj: {},
      examDetail: {},
      answerSheetList: [],
      checkedCities: [],
      keepTime: "",
      userAnswerList: [],
      totalNum: 0,
      hour: 0, minute: 0, second: 0, millisecond: 0,
      limitTime: "",
      isHint: false,
      beginDateTime: "",
      isLimitTime: false,
      activeName: '',
      isJx: false,
      imgUlrObj: "",
      timeoutImg: null,
      loading: true
    }
  },
  created() {
    that = this;
    // that.contentHeight.height=window.innerHeight-280+'px';
    setTimeout(function () {
      that.getCateExerciseList();
    }, 600)
  },
  beforeDestroy() {
    clearTimeout(that.timeoutImg);
  },
  methods: {
    //练习详情
    getCateExerciseList() {
      let url = "/exercise/exerciseDetails";
      let data = { exerciseId: this.$route.query.exerciseId };
      getExam(url, data).then(res => {
        that.loading = false;
        if (res.success) {
          that.isLimitTime = res.data.isLimitTime;
          that.oldExamObj = res.data;
          that.limitTime = res.data.limitTime;
          that.examObj = {};
          that.answerSheetList = [];
          that.examObj = JSON.parse(JSON.stringify(that.oldExamObj));
          var number = 0;
          that.examObj.paperEntity.paperAreaList.forEach((obj) => {
            obj.questionList.forEach((questionObj) => {
              number = number + 1;
              questionObj.number = number;
              var answerN = "";
              questionObj.questionAnswers.forEach((answersObj, index) => {
                switch (index) {
                  case 0:
                    answersObj.nName = "A";
                    break;
                  case 1:
                    answersObj.nName = "B";
                    break;
                  case 2:
                    answersObj.nName = "C";
                    break;
                  case 3:
                    answersObj.nName = "D";
                    break;
                  case 4:
                    answersObj.nName = "E";
                    break;
                  case 5:
                    answersObj.nName = "F";
                    break;
                  case 6:
                    answersObj.nName = "G";
                    break;
                }
                if (answersObj.isRight) {
                  if (answerN != "") {
                    answerN = answerN + "," + answersObj.nName
                  } else {
                    answerN = answerN + answersObj.nName
                  }

                }
              });
              questionObj.rightAnswerName = answerN;
            });
            that.answerSheetList.push({ titleName: obj.paperAreaName, list: obj.questionList })
          });
          that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
          that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
          that.start();
          that.beginDateTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss");

        } else {
          this.$message.error(res.message)
        }
      })
    },
    clickAnswer(examDetail, detail) {//单选题 选择答案 examDetail:题目详情  detail:答案详情
      that.radio = [detail.id];
      /*循环答题卡,修改答题卡状态*/
      that.answerSheetList.forEach((answerSheetObj) => {
        answerSheetObj.list.forEach((obj) => {
          obj.questionAnswers.forEach((answersObj) => {
            if (answersObj.id == detail.id) {
              obj.isRight = detail.isRight;
              examDetail.isRightUser = detail.isRight;
              obj.answerId = detail.id;
            }
            if (examDetail.id == obj.id && answersObj.isRight) {
              obj.answerName = answersObj.nName;
              examDetail.answerName = answersObj.nName;
            }
          });

        })
      });

      var indexNext = 0;
      var isRight = false;
      var isExist = false;
      that.examObj.paperEntity.paperAreaList.forEach((obj) => {
        obj.questionList.forEach((questionObj, index) => {
          questionObj.questionAnswers.forEach((answersObj) => {
            if (answersObj.id == detail.id) {
              questionObj.isRight = detail.isRight;
              questionObj.answerId = detail.id;

              if (index == obj.questionList.length - 1) {
                indexNext = 0;
              } else {
                indexNext = index + 1;
              }
              isRight = detail.isRight;
            }
          });
          if (indexNext == index && isRight && that.examObj.exerciseType == "1") {//答对的话 默认跳转到下一题
            that.examDetail = questionObj;
            if (questionObj.isRight != undefined && questionObj.answerId != undefined&& questionObj.answerId !=="") {
              that.examDetail.isDisabled = true;
              that.radio = [questionObj.answerId];
            } else {
              that.examDetail.isDisabled = false;
              that.radio = [];
            }
            isRight = false;
            isExist = true;
            that.activeName = "";
            return false;
          }
        });
      });
      if (!isExist) {
        that.examDetail.isDisabled = true;
      }

    },
    checkboxAnswer(examDetail) {//多选题 选择答案 examDetail:题目详情  detail:答案详情
      that.activeName = "";
      that.checkedCities.sort(function (a, b) {
        return a - b;
      });
      var answerId = "";
      that.checkedCities.forEach(function (c) {
        answerId = answerId + c + ","
      });
      var answer = "";
      var answerN = "";
      var answerList = [];
      that.examObj.paperEntity.paperAreaList.forEach((obj) => {
        obj.questionList.forEach((questionObj, index) => {
          questionObj.questionAnswers.forEach((answersObj, index) => {
            if (examDetail.id == questionObj.id) {
              questionObj.answerId = answerId;
              if (answersObj.isRight) {
                answerList.push(answersObj.id);
                answerN = answerN + answersObj.nName + ","
              }
              if (index + 1 == questionObj.questionAnswers.length) {
                answerList.sort(function (a, b) {
                  return a - b;
                });
                answerList.forEach(function (t) {
                  answer = answer + t + ","
                });
                questionObj.answerName = answerN;
                if (answer == answerId) {
                  questionObj.isRight = true;
                  if (that.examObj.exerciseType == "1") {
                    {
                      that.nextQuestion();
                    }
                  }
                } else {
                  that.examDetail.isDisabled = true;
                  questionObj.isRight = false;
                  that.examDetail = questionObj;
                }
              }
            }
          });
        });
      });

    },
    clickAnswerSheet(detail) {//点击答题卡
      that.activeName = "";
      that.examDetail = detail;
      that.checkedCities = [];
      that.radio = [];
      var list = [];
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(detail.answerId);
      }
      if (detail.answerId != undefined && detail.answerId !== '') {
        that.examDetail.isDisabled = true;
      }
    },
    onTopic() {//上一题
      that.activeName = "";
      if (that.examDetail.number == that.totalNum) {
        this.$message({
          type: 'warning',
          message: '注:该题已是试卷最后一题,请检查试卷是否都已做完'
        });
      } else {

      }
      that.checkedCities = [];
      that.radio = [];
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i != 0) {
              that.examDetail = that.answerSheetList[c].list[i - 1];
            } else {
              that.examDetail = that.answerSheetList[c - 1].list[that.answerSheetList[c - 1].list.length - 1];
            }

          }
        }
      }
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(that.examDetail.answerId);
      }
      if (that.examDetail.answerId != undefined &&that.examDetail.answerId !=="") {
        that.examDetail.isDisabled = true;
      }
    },
    nextQuestion() {//下一题
      that.activeName = "";
      if (that.examDetail.number == that.totalNum) {
        this.$message({
          type: 'warning',
          message: '注:该题已是试卷最后一题,请检查试卷是否都已做完'
        });
        that.examDetail.isDisabled = true;
        return false
      } else {

      }
      that.checkedCities = [];
      that.radio = [];

      var detail = {};
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i >= that.answerSheetList[c].list.length - 1) {
              detail = that.answerSheetList[c + 1].list[0];
            } else {
              detail = that.answerSheetList[c].list[i + 1];
            }

          }
        }
      }
      that.examDetail = detail;
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(that.examDetail.answerId);
      }
      if (that.examDetail.answerId != undefined&&that.examDetail.answerId !=="") {
        that.examDetail.isDisabled = true;
      }
    },
    subPaper() {//交卷
      var totalTime = "";
      if (that.isLimitTime) {
        var residueTime = that.hour * 3600000 + that.minute * 60000 + that.second * 1000;//模拟考剩余时间
        var totleTime = that.limitTime * 60000;//考试总时间
        var availableTime = (totleTime - residueTime) / 60000;
        var hour = parseInt(availableTime / 60);
        var minute = parseInt(availableTime % 60);
        var second = (availableTime * 60) % 60;
        var hourObj = hour > 9 ? hour : "0" + hour;
        var minuteObj = minute > 9 ? minute : "0" + minute;
        var secondObj = second > 9 ? second : "0" + second;
        totalTime = hourObj + ':' + minuteObj + ':' + secondObj;
      } else {
        totalTime = that.keepTime;
      }

      this.$confirm('确定要交卷吗', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        clearTimeout(that.timeoutImg);
        var paramData = {
          "exerciseId": that.examObj.exerciseId,
          "score": 0,
          "beginDateTime": that.beginDateTime,
          "totalTime": totalTime,
          courseId: that.$route.query.courseId,
          paperId: that.examObj.paperEntity.paperId,
          "endDateTime": (new Date()).Format("yyyy-MM-dd hh:mm:ss"),
          "exerciseAnswersList": [],
          exercisePicture: that.imgUlrObj
        };
        var score = 0;
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj) => {
            if(questionObj.questionType=="多选题"){

            }else{
              if (questionObj.isRight) {
                score = score + questionObj.score
              }
            }

            paramData.exerciseAnswersList.push(
                {
                  "isRight": questionObj.isRight != undefined && questionObj.isRight ? questionObj.isRight : false,
                  "answerName": questionObj.answerName ? questionObj.answerName : "",
                  "answerId": questionObj.answerId ? questionObj.answerId.toString() : "",
                  "questionId": questionObj.id,
                  "paperAreaId": obj.id
                }
            )
          });
        });
        that.examObj.totalTime = totalTime;
        that.examObj.beginDateTime = that.beginDateTime;//开始时间
        that.examObj.assignmentTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss");//交卷时间;
        paramData.score = score;
        let url = "/exercise/submitPaperExercise";
        let data = { paperJson: JSON.stringify(paramData) };
        getExamByPost(url, data).then(res => {
          if (res.success) {
            this.loading = false;
            sessionStorage.setItem("examObj", JSON.stringify(that.examObj));
            this.$message.success('提交成功')
            this.$router.push({
              path: "/examRecord"
            });
          } else {
            this.$message.error(res.message)
          }
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    restart() {//重新开始
      this.$confirm('确定要重新开始吗', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        that.radio = [];
        that.examObj = {};
        that.answerSheetList = [];
        that.examObj = JSON.parse(JSON.stringify(that.oldExamObj));
        var number = 0;
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj) => {
            number = number + 1;
            questionObj.number = number;
            var answerN = "";
            questionObj.questionAnswers.forEach((answersObj, index) => {
              switch (index) {
                case 0:
                  answersObj.nName = "A";
                  break;
                case 1:
                  answersObj.nName = "B";
                  break;
                case 2:
                  answersObj.nName = "C";
                  break;
                case 3:
                  answersObj.nName = "D";
                  break;
                case 4:
                  answersObj.nName = "E";
                  break;
                case 5:
                  answersObj.nName = "F";
                  break;
                case 6:
                  answersObj.nName = "G";
                  break;
              }
              if (answersObj.isRight) {
                if (answerN != "") {
                  answerN = answerN + "," + answersObj.nName
                } else {
                  answerN = answerN + answersObj.nName
                }

              }
            });
            questionObj.rightAnswerName = answerN;
          });
          that.answerSheetList.push({ titleName: obj.paperAreaName, list: obj.questionList })
        });
        that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
        that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
        that.start();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    timer() {
      that.millisecond = that.millisecond + 50;
      that.second = that.second + 1;
      if (that.second >= 60) {
        that.second = 0;
        that.minute = that.minute + 1;
      }

      if (that.minute >= 60) {
        that.minute = 0;
        that.hour = that.hour + 1;
      }
      var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
      var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
      var secondObj = that.second > 9 ? that.second : "0" + that.second;
      that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
    },
    timer2() {/*模拟考 减*/
      if (that.hour == 0 && that.minute <= 15 && that.isLimitTime) {
        that.isHint = true;
      }
      if (that.hour === 0 && that.minute === 0 && that.second === 0 && that.isLimitTime) {
        window.clearInterval(int);
        this.$alert("考试时间已结束,已提交试卷", '提示', {
          confirmButtonText: '确定',
          callback: action => {
            var totalTime = "";
            if (that.isLimitTime) {
              var residueTime = that.hour * 3600000 + that.minute * 60000 + that.second * 1000;//模拟考剩余时间
              var totleTime = that.limitTime * 60000;//考试总时间
              var availableTime = (totleTime - residueTime) / 60000;
              var hour = parseInt(availableTime / 60);
              var minute = parseInt(availableTime % 60);
              var second = (availableTime * 60) % 60;
              var hourObj = hour > 9 ? hour : "0" + hour;
              var minuteObj = minute > 9 ? minute : "0" + minute;
              var secondObj = second > 9 ? second : "0" + second;
              totalTime = hourObj + ':' + minuteObj + ':' + secondObj;
            } else {
              totalTime = that.keepTime;
            }
            var paramData = {
              "exerciseId": that.examObj.exerciseId,
              "score": 0,
              courseId: that.$route.query.courseId,
              paperId: that.examObj.paperEntity.paperId,
              "beginDateTime": that.beginDateTime,
              "endDateTime": (new Date()).Format("yyyy-MM-dd hh:mm:ss"),
              "totalTime": totalTime,
              "exerciseAnswersList": [],
              exercisePicture: that.imgUlrObj
            };
            var score = 0;
            that.examObj.paperEntity.paperAreaList.forEach((obj) => {
              obj.questionList.forEach((questionObj) => {
                if (questionObj.isRight) {
                  score = score + questionObj.score
                }
                paramData.exerciseAnswersList.push(
                    {
                      "isRight": questionObj.isRight ? questionObj.isRight : false,
                      "answerName": questionObj.answerName ? questionObj.answerName : "",
                      "answerId": questionObj.answerId ? questionObj.answerId : "",
                      "questionId": questionObj.id
                    }
                )
              });
            });
            that.examObj.totalTime = totalTime;
            that.examObj.beginDateTime = that.beginDateTime;//开始时间
            that.examObj.assignmentTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss");//交卷时间
            paramData.score = score;
            let url = "/exercise/submitPaperExercise";
            let data = { paperJson: JSON.stringify(paramData) };
            getExamByPost(url, data).then(res => {
              if (res.success) {
                this.loading = false;
                sessionStorage.setItem("examObj", JSON.stringify(that.examObj));
                this.$message.success('提交成功')
                this.$router.push({
                  path: "/examRecord"
                });
              } else {
                this.$message.error(res.message)
              }
            });
          }
        });

      } else {
        that.second = that.second - 1;
      }
      if (that.second <= 0 && that.minute > 0) {
        that.second = 60;
        that.minute = that.minute - 1;
      }

      if (that.minute <= 0 && that.hour > 0) {
        that.minute = 60;
        that.hour = that.hour - 1;
      }
      var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
      var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
      var secondObj = that.second > 9 ? that.second : "0" + that.second;
      that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
    },
    //开始函数
    start() {
      that.hour = 0;
      that.minute = 0;
      that.second = 0;//初始化
      window.clearInterval(int);
      if (that.limitTime != undefined && that.limitTime !== "" && that.limitTime !== 0) {
        if (that.limitTime > 60) {
          that.hour = parseInt(that.limitTime / 60);
          that.minute = that.limitTime % 60;
          if (that.hour > 1 && that.minute == 0) {
            that.hour = that.hour - 1;
            that.minute = 59;
          } else {
            that.minute = that.limitTime % 60 - 1;
          }

        } else {
          that.minute = that.limitTime != undefined && that.limitTime > 0 ? that.limitTime - 1 : that.limitTime;
        }
        that.second = 60;
        int = setInterval(that.timer2, 1000);//每隔50毫秒执行一次timer函数
      } else {
        int = setInterval(that.timer, 1000);//每隔50毫秒执行一次timer函数
      }
    },
    stop() {
      window.clearInterval(int);
    },
    //返回上一页
    goBack() {
      this.$router.push({
        path: "/examList"
      });
    },
    getUlr(imgUrl) {
      that.imgUlrObj = that.imgUlrObj + imgUrl + ","
    },
  },
  destroyed: function () {
    window.clearInterval(int);
  }
}
